import { useContext } from "react";
import Web3Ctx from "../components/Context/Web3Ctx.js";

const useWeb3Ctx = () => {
    return useContext(Web3Ctx)
}

export default useWeb3Ctx;